<template>
    <div class="statistics2">
        <p class="return pointer no-wrap font-size16" @click="gohomefunc">返回</p>
        <el-tabs v-model="activeName" class="m-tab">
            <el-tab-pane label="分数段统计" name="score" v-loading="loading">
                <div style="display: flex;justify-content: space-between">
                    <el-form inline>
                        <el-form-item label="分数段">
                            <el-input-number
                                v-model="scoreInput"
                                controls-position="right"
                                :step="10"
                                :min="10"
                                :max="Math.floor(total / 2)"
                            ></el-input-number>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary">确定</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <h3>表格</h3>
                <el-table :data="list">
                    <el-table-column
                        v-for="index in fragmentCount"
                        :key="index"
                        :label="getLabel(index)"
                        :prop="'step' + index"
                    ></el-table-column>
                </el-table>
                <h3 style="margin-top: 30px">柱形图</h3>
                <div id="result-bar" style="height: 500px"></div>
            </el-tab-pane>
            <el-tab-pane label="排名统计" name="topList" v-loading="loading">
                <el-form inline class="xy-between">
                    <el-form-item label="用户组">
                        <user-group-selector
                            v-model="query.groupSelect"
                            @change="loadTop()"
                        >
                        </user-group-selector>
                    </el-form-item>
                    <el-form-item>
                        <div class="xy-start">
                            <el-input
                                placeholder="请输入关键字检索"
                                v-model="query.searchKey"
                            ></el-input>
                            <el-button
                                type="primary"
                                style="margin-left: 10px"
                                @click="loadTop()"
                            >检索
                            </el-button>
                        </div>
                    </el-form-item>
                </el-form>
                <el-table :data="topList">
                    <el-table-column
                        label="用户名"
                        prop="UserName"
                    ></el-table-column>
                    <el-table-column
                        label="真实姓名"
                        prop="RealName"
                    ></el-table-column>
                    <el-table-column
                        label="联系电话"
                        prop="Telephone"
                    ></el-table-column>
                    <el-table-column
                        label="所属用户组"
                        :formatter="defaultVal"
                        prop="GroupName"
                    ></el-table-column>
                    <el-table-column
                        label="考试成绩"
                        prop="ExamScore"
                    ></el-table-column>
                    <el-table-column
                        label="答卷时长"
                        prop="ExamTime"
                        :formatter="secFormat"
                    ></el-table-column>
                    <el-table-column
                        label="排名"
                        prop="Ranking"
                    ></el-table-column>
                </el-table>
                <div class="xy-center pv-16">
                    <el-button
                        v-show="topList.length!==0"
                        type="primary"
                        @click="exportRank"
                        :loading="saving"
                    >导出排名
                    </el-button
                    >
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import * as echarts from "echarts";
import { cleanNoneParam, secFormat } from "@/utils";
import { GetRanking, GetScoreStage } from "@/api/manage";
import UserGroupSelector from "@/components/manager/UserGroupSelector";
import tableFormatter from "@/mixins/tableFormatter";

export default {
    name: "result-statistics2",
    components: { UserGroupSelector },
    mixins: [tableFormatter],
    data() {
        return {
            activeName: "score",
            scoreInput: 20,
            total: 0,
            loading: false,
            query: {
                groupSelect: "",
                searchKey: ""
            },
            rawList: [], // 原始的分数段统计
            topList: [],
            saving: false
        };
    },
    created() {
        this.total = parseFloat(this.$route.query.totalScore);
    },
    mounted() {
        this.loading = true;
        Promise.all([this.loadStage(), this.loadTop()]).then(() => {
            this.loading = false;
        });
    },
    watch: {
        scoreInput(newValue, oldValue) {
            this.loadStage();
        }
    },
    computed: {
        list() {
            let data = {};
            for (let i = 0; i < this.fragmentCount; i++) {
                data["step" + (i + 1)] = this.rawList[i];
            }
            return [data];
        },
        // 分数段的数量
        fragmentCount() {
            return this.rawList.length;
        }
    },
    methods: {
        gohomefunc() {
            this.$router.go(-1)
        },
        getLabel(serial) {
            let b = serial * this.scoreInput;
            let a = b - this.scoreInput;
            return `${a}~${b}分`;
        },
        setBar() {
            let labels = [];
            for (let i = 0; i < this.fragmentCount; i++) {
                labels.push(this.getLabel(i + 1));
            }
            let data = this.rawList;
            this.bar.setOption({
                tooltip: {
                    trigger: "axis",
                    axisPointer: { type: "cross" }
                },
                xAxis: {
                    data: labels
                },
                yAxis: {
                    type: "value",
                    name: "人数",
                    axisLabel: {
                        formatter: "{value} 人"
                    }
                },
                series: [
                    {
                        name: "人数",
                        type: "bar",
                        barWidth: "50%",
                        data
                    }
                ]
            });
        },
        // 加载分数段统计
        loadStage() {
            return GetScoreStage({
                ExamId: this.$route.query.examId,
                ScoreStage: this.scoreInput,
                TotalScore: this.$route.query.totalScore
            }).then((data) => {
                this.rawList = data;
                this.bar = echarts.init(document.getElementById("result-bar"));
                this.setBar();
            });
        },
        // 加载排名
        loadTop() {
            return GetRanking({
                ExamId: this.$route.query.examId,
                ...cleanNoneParam(this.query)
            }).then((data) => {
                this.topList = data;
            });
        },
        async exportRank() {
            const json = this.topList.map((item) => {
                return {
                    用户名: item.UserName,
                    真实姓名: item.RealName,
                    联系电话: item.Telephone,
                    所属用户组: item.GroupName,
                    考试成绩: item.ExamScore,
                    答卷时长: secFormat(item.ExamTime),
                    排名: item.Ranking
                };
            });
            this.saving = true;
            const XLSX = await import("xlsx");
            const sheet1 = XLSX.utils.json_to_sheet(json);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, sheet1, "排名统计");
            this.saving = false;
            XLSX.writeFile(wb, "排名统计.xlsx");
        }
    },
    beforeDestroy() {
        this.bar.dispose();
    }
};
</script>

<style scoped lang="less">
.statistics2 {
    position: relative;

    ::v-deep .el-tabs__nav-wrap .el-tabs__item {
        padding: 28px 0 28px 48px;
        line-height: 0.8;
    }

    .return {
        z-index: 10;
        color: #969799;
        position: absolute;
        top: 0.05rem;
        left: 0.1rem;
    }

    ::v-deep .el-tabs__content {
        padding: 28px 48px;
    }

    ::v-deep .el-tabs__nav {
        margin-left: 0.2rem;
    }

}
</style>
